import "./koha.css";
import imgBanner from "../assest/about_us.jpg";

function Career() {
  return (
    <div className="career-page">
      {/* ===================== BANNER ===================== */}
      <div className="about-banner">
        <img src={imgBanner} alt="banner" className="banner-img" />
        <div className="banner-text">
          <h1>Koha MLS</h1>
        </div>
      </div>
      <div className="body-container">
        <div className="bg-blobs"></div>
        <div className="bg-blobs2"></div>
        <div className="floating-dots"></div>
        {/* koha lms installation */}
        <section className="team-section mt-5">
          <h2 className="section-heading text-center mb-5">
            <span className="line"></span> Koha LMS Installation <span className="line"></span>
          </h2>

          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-8">
                <h4>Customized Koha Installation and Implementations</h4>
                <p className="career-text">
                  At Click Informatics we provide every kind of customized service for Koha Installation in your college library. We do data migration from your old college library software to Koha so that you not face any data mismatch issue in audits. Our services include the management of databases with real-time backups, and the installation of updates and upgrades to both the Linux server and your Koha ILS software. We also have options for installing Koha on local servers at your library. With the correct remote access we could completely manage the installation at your library.
                </p>
                <h4>Data Migration and Data Manipulation</h4>
                <p className="career-text">
                  Library data is the most important part to representation of a library's collection, we take the time to proficiently manage your data. Before we move your data into any new system we check each record for accuracy, identifying and manipulating each record for the correct encoding and diacritical display. We work closely with each library to ensure there are no duplicate entries and to consistently use the highest quality records for complete accuracy of bibliographic detail.
                </p>

                <h4>Koha Training</h4>
                <p>The goal of this course is to provide the practicing librarian with the skills and knowledge needed in the process of automating library operations and services. This course basically focuses on automating or computerizing library system with a view to accomplish various library functions such as acquisition, circulation, cataloguing, subscription management, patron management and many more, effectively and efficiently. <br /> The objectives of this program are to:
                    <ul>
                        <li>Train library staff on using Koha.</li>
                        <li>To test and certify their readiness to use Koha</li>
                    </ul>
                </p>

                <h4>Koha Cloud Hosting</h4>
                <p>We provide cloud hosting for koha open source software.Koha LMS can be Accessed anywhere, any time, on any device by using cloud hosting.To access your Koha installation, you only need a web browser and an Internet connection. Hosting Koha on cloud is a cost effective and convenient setup as you do not have to own the computers server or maintain the operating system and application hardware. We take care of that for you.</p>

                <h4>Expert Support</h4>
                <p>Our Koha expert provide services 24*7 you can talk to them anytime over call and understand the process of migration and Koha Software installation.</p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Career;
